// @flow
import mapBaseLayerReducer, { initialState as baseInitialState, creationFunctions } from 'catena/er2_map_userlayers/js/reducers/mapbaselayer'
import * as imageSrc from 'catena/er2_map_baselayers/images'
import BingMaps from 'ol/source/BingMaps'
import Tile from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'

const makeBingLayer = (layerType: string, apiKey: string) => new Tile({
    visible: true,
    preload: Infinity,
    source: new BingMaps({
        key: apiKey,
        imagerySet: layerType,
    }),
})

const makeLocalGeoserver = () => {
    const url = 'http://localhost:32773/geoserver/wms'
    return new Tile({
        source: new TileWMS({
            url,
            params: { LAYERS: 'ficus:CDL_2017', TILED: true },
            serverType: 'geoserver',
        }),
    })
}

// Override the behavior of the map, or disable it here
const mapBaseLayerInitialState = Object.assign({}, baseInitialState, {})
// Assume "none" is the last baselayer for simplicity
const none = baseInitialState.baseLayerChoices[baseInitialState.baseLayerChoices.length - 1]
mapBaseLayerInitialState.baseLayerChoices = [...baseInitialState.baseLayerChoices.slice(0, baseInitialState.baseLayerChoices.length - 2), {
    name: 'Bing Aerial',
    imageSrc: imageSrc.bingAerialIcon,
    create: apiKeys => makeBingLayer('Aerial', apiKeys.bing),
}, {
    name: 'Bing Aerial/Labels',
    imageSrc: imageSrc.bingAerialLabelsIcon,
    create: apiKeys => makeBingLayer('AerialWithLabels', apiKeys.bing),
}, {
    name: 'Bing Road',
    imageSrc: imageSrc.bingRoadIcon,
    create: apiKeys => makeBingLayer('Road', apiKeys.bing),
// }, {
//    name: 'Local WMS',
//    imageSrc: imageSrc.noneIcon,
//    create: () => makeLocalGeoserver(),
}, none]

export default function catenaMapBaseLayerReducer(initialState = mapBaseLayerInitialState, action) {
    return mapBaseLayerReducer(initialState, action)
}
